var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from 'react';
import classNames from 'classnames';
import '../../css/clydeFileUpload.css';
var ClydeFileUpload = function (props) {
    var buttonText = props.buttonText, className = props.className, disabled = props.disabled, hidden = props.hidden, id = props.id, uploadedFiles = props.uploadedFiles, validTypes = props.validTypes;
    var _a = useState(''), error = _a[0], setError = _a[1];
    var handleFileChange = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var setUploadedFiles, files, validFileTypes, validFileTypesList, maxSize, fileType, idx, fileName, splitFileName, filePromises, _i, files_1, file;
        return __generator(this, function (_a) {
            if (disabled || hidden) {
                return [2 /*return*/];
            }
            setUploadedFiles = props.setUploadedFiles;
            files = e.target.files;
            setError('');
            if (files.length > 5) {
                setError('A maximum of 5 files can be added.');
                return [2 /*return*/];
            }
            validFileTypes = validTypes && validTypes.length ? validTypes : ['png', 'jpg', 'jpeg', 'gif', 'pdf'];
            validFileTypesList = validTypes && validTypes.length ? validTypes.join(', ') : '.png, .jpg, .pdf, or .gif';
            maxSize = 10 * 1000 * 1000;
            for (idx = 0; idx < files.length; idx++) {
                fileName = files[idx].name;
                // MARKER AJC 2022/06/13 I believe the below ternary is reversed. It should be fixed and tested extensively.
                fileType = files[idx].type ? '' : files[idx].type.split('/')[1];
                if (fileType === '' || fileType === undefined) {
                    splitFileName = fileName.split('.');
                    fileType = splitFileName[splitFileName.length - 1];
                }
                if (validFileTypes.indexOf(fileType.toLowerCase()) === -1) {
                    setError("Unsupported format. Files must be in the ".concat(validFileTypesList, " format."));
                    return [2 /*return*/];
                }
                if ((files[idx].size) > maxSize) {
                    setError('File is too large. Please use a file smaller than 5mb.');
                    return [2 /*return*/];
                }
            }
            filePromises = [];
            for (_i = 0, files_1 = files; _i < files_1.length; _i++) {
                file = files_1[_i];
                filePromises.push(toBase64(file));
            }
            Promise.all(filePromises).then(function (resultFiles) {
                setUploadedFiles(resultFiles);
            });
            return [2 /*return*/];
        });
    }); };
    var toBase64 = function (file) { return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () { return (resolve({
            data: reader.result,
            name: file.name,
            type: file.type,
        })); };
        reader.onerror = function (readerError) { return reject(readerError); };
    }); };
    var _buttonText = buttonText || 'Upload Files';
    var _className = classNames('clyde-file-upload-container', className, {
        'clyde-file-upload-container--disabled': disabled,
        'clyde-file-upload-container--hidden': hidden,
    });
    return (React.createElement("div", { className: _className, id: id || '' },
        React.createElement("div", { className: 'clyde-file-upload' },
            React.createElement("input", { className: 'clyde-file-upload__input', multiple: true, name: 'uploadedFiles', onChange: handleFileChange, onMouseUp: function (e) { e.target.blur(); }, type: 'file' }),
            React.createElement("div", { className: 'clyde-file-upload__img' }),
            React.createElement("ul", { className: 'clyde-file-upload__file-list' }, uploadedFiles && uploadedFiles.length > 0
                ? uploadedFiles.map(function (file, idx) { return (React.createElement("li", { className: 'clyde-file-upload__file-list__file', key: idx }, file.name)); })
                : React.createElement("li", { className: 'clyde-file-upload__file-list__info' }, _buttonText))),
        error && React.createElement("span", { className: 'clyde-file-upload-error' }, error)));
};
export default ClydeFileUpload;
